import { render, staticRenderFns } from "./EditRewardItemDialog.vue?vue&type=template&id=000180a3"
import script from "./edit-reward-item-dialog.ts?vue&type=script&lang=ts&external"
export * from "./edit-reward-item-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-reward-item-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports